import { packageUrl } from './package'

/*
 * Archivos que la guía carga para los jugadores. Todos salen del paquete del 08/10/2026
 * (ver package.ts). Los conteos esperados se toman de 00_control.csv en el panel técnico.
 * 26_raw_bag_rows, 18/24, 29, 32, 44–47 solo se comprueban en el panel. 23 y 25 resuelven la calidad de las recompensas.
 */
const src = (filename: string) => ({ label: filename, url: packageUrl(filename), expected: undefined as number | undefined })

export const worldSources = {
  items: src('01_items.csv'),
  variants: src('02_item_variants.csv'),
  categories: src('03_categories.csv'),
  classes: src('04_classes.csv'),
  itemClasses: src('05_item_classes.csv'),
  monsters: src('06_monsters.csv'),
  maps: src('07_maps.csv'),
  spawns: src('08_spawns.csv'),
  locations: src('09_monster_locations.csv'),
  routes: src('10_drop_routes.csv'),
  routeTargets: src('11_route_targets.csv'),
  rules: src('12_item_drop_rules.csv'),
  ruleTargets: src('13_item_drop_rule_targets.csv'),
  routeEvents: src('14_route_events.csv'),
  bags: src('16_bags.csv'),
  bagTriggers: src('17_bag_triggers.csv'),
  bagSections: src('19_bag_sections.csv'),
  bagRewardPools: src('20_bag_reward_pools.csv'),
  bagRewards: src('21_bag_rewards.csv'),
  bagRewardVariants: src('22_bag_reward_variants.csv'),
  /** Perfil de opciones por variante de recompensa (calidad calculada, p. ej. excellent_count). */
  bagVariantProfiles: src('23_bag_variant_profiles.csv'),
  optionProfiles: src('25_option_profiles.csv'),
  events: src('27_events.csv'),
  eventSchedules: src('28_event_schedules.csv'),
  eventMapChoices: src('30_event_map_choices.csv'),
  eventRooms: src('33_event_rooms.csv'),
  eventBags: src('34_event_bags.csv'),
  eventItems: src('35_event_direct_items.csv'),
  quests: src('36_quests.csv'),
  questRules: src('37_quest_rules.csv'),
  questRuleClasses: src('38_quest_rule_classes.csv'),
  questObjectives: src('39_quest_objectives.csv'),
  questObjectiveClasses: src('40_quest_objective_classes.csv'),
  questDropRules: src('41_quest_drop_rules.csv'),
  questDropRuleTargets: src('42_quest_drop_rule_targets.csv'),
  rates: src('43_server_rates.csv'),
}

export type SourceKey = keyof typeof worldSources

/** Ya no hay copias: el paquete trae un solo archivo por tabla. */
export const copyPairs: { copy: SourceKey; original: SourceKey }[] = []

/** Comprobaciones históricas indicadas por el staff (se contrastan, no se imponen). */
export const expectedChecks = {
  spots: 971,
  invasionSpawns: 58,
  monstersWithoutLocation: 177,
  dungeonLevels: [80, 95, 110],
  redDragonMaps: ['Lorencia', 'Noria', 'Devias'],
}
